<form [formGroup]="numberPlatesForm">

  <table class="common-style">
    <tr>
      <th>{{'active'| translate:['tmc-yard.widget.transport-creation-profiles.active', translationService.language]}}
      </th>
      <th>{{'number-plate'| translate:['tmc-yard.widget.transport-creation-profiles.number-plate',
        translationService.language]}}</th>
      <th></th>
    </tr>
    <tr *ngFor="let numberPlate of numberPlates">
      <td class="centered-column">
        <div (click)="changeActive(numberPlate)">
          <i *ngIf="!numberPlate.active" class="fa-regular fa-square pointer"></i>
          <i *ngIf="numberPlate.active" class="fa-regular fa-square-check pointer"></i>
        </div>
      </td>
      <td>
        {{numberPlate.numberPlate}}
      </td>
      <td>
        <div (click)="this.delete(numberPlate)">
          <sc-icon iconClass="fa-trash pointer"></sc-icon>
        </div>
      </td>
    </tr>
    <tr *ngIf="numberPlates == null || numberPlates.length === 0">
      <td colspan="3" class="centered-column">
        {{'no data'| translate:['tmc-yard.common.message.no-data', translationService.language]}}
      </td>
    </tr>

  </table>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>

  <sc-flex>
    <sc-string-field
      [label]="'number-plate'| translate:['tmc-yard.widget.transport-creation-profiles.number-plate', translationService.language]"
      formControlName="newNumberPlate"></sc-string-field>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <button mat-icon-button type="button" [disabled]="!addNewEnabled()" (click)="this.addNewNumberPlate()">
      <i class="fa-light
         fa-plus"></i>
    </button>
  </sc-flex>
</form>